import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import Iframe from 'react-iframe';

const useStyles = makeStyles(theme => ({
    fileOfScheduleBox: {
        backgroundColor: 'white'
    },
    overlayEditor: {
        position: 'absolute',
        top: 0,
        left: 0,
        margin: 0,
        border: 'none'
    }
}))

const useOtherStyle = makeStyles({
    zoom: zoomRate => ({
        '-ms-zoom': `${zoomRate.width}`,
        '-moz-transform': `scale(${zoomRate.width}, ${zoomRate.height})`,
        '-moz-transform-origin': '0 0', '-o-transform': `scale(${zoomRate.width}, ${zoomRate.height})`,
        '-o-transform-origin': '0 0', '-webkit-transform': `scale(${zoomRate.width}, ${zoomRate.height})`,
        '-webkit-transform-origin': '0 0',
        transform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        transformOrigin: '0 0'
    })
});

const OverlayItem = (props) => {
    const { itemData, pivot, resolution, screenSize, index, si } = props;
    const classes = useStyles();
    const zoomRate = {
        width: screenSize.width / (resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 1 : 0] : '1280'),
        height: screenSize.height / (resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 0 : 1] : '720')
    }
    const classes2 = useOtherStyle(zoomRate);

    useEffect(() => {
        onLoadIframe();
    }, [itemData.overlay])

    const onLoadIframe = () => {
        if (document.getElementById(`overlay-${si}-${index}`)) {
            document.getElementById(`overlay-${si}-${index}`).contentWindow.document.body.innerHTML = (itemData.overlay || '');
        }
    }

    return (
        <Iframe src={process.env.PUBLIC_URL + "/infochannel-overlay.html"}
            width={resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 1 : 0] : '1280'}
            height={resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 0 : 1] : '720'}
            id={`overlay-${si}-${index}`}
            className={classnames(classes.overlayEditor, classes2.zoom)}
            onLoad={onLoadIframe} />

    )
}

export default OverlayItem